import { DefaultButton, mergeStyles, mergeStyleSets, PrimaryButton, Stack } from 'office-ui-fabric-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import FormHeader from '../FormHeader';
import NewFormField from '../../../../common/layout/form/NewFormField';
import FormDropDown from '../../../../common/layout/form/FormDropDown';
import FormDatePicker from '../../../../common/layout/form/FormDatePicker';
import FileInput from '../../../../common/layout/form/FileInput';
import { buttonS } from '../../../../common/styles/formBtns.styles';
import { useCancelForm } from '../../../hooks/useCancelForm';
import { useFilesUploadForm } from '../../../hooks/useFilesUploadForm';
import { margin, btnContainer } from "../../../styles/panelForm.styles";
import ActivityIndicator from '../../../../common/layout/ActivityIndicator';
import ErrorMessage from "../../../../common/layout/form/ErrorMessage";
import {
  containerS,
} from "../../../styles/pickUpPointsForm.styles";

// const controlClass = mergeStyleSets({
//   control: {
//     margin: "0 40px 0 0",
//     backgroundColor: "red",
//     maxWidth: "300px",
//   },
// });

// The date was required by the native date input (HTML required attribute); the date picker needs explicit validation
const filesUploadSchema = yup.object().shape({
  documentDate: yup.string().required(),
});

const FilesUploadForm = () => {
  const { t } = useTranslation("admin");
  const {
    arrangementFileHandler, 
    handleSubmit,
    isLoading
  } = useFilesUploadForm();

  const cancel = useCancelForm();

  const btns = mergeStyles({
    position: "absolute",
    bottom: 30,
    left: 40,
  });
  
  return(
    <Formik 
      onSubmit={handleSubmit} 
      initialValues={{}}
      validationSchema={filesUploadSchema}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ handleSubmit }) => (
        <Form translate="yes" onSubmit={handleSubmit}>
          <Stack styles={containerS} verticalAlign="space-between" verticalFill>
          <Stack.Item>

          <FormHeader text={t("nav.panelAddFile") as string}/>
          <NewFormField name="description" label={t("nav.itemDescription") as string} />
          <FormDatePicker name="documentDate" label={t("nav.documentDate") as string} placeholder={t("nav.selectDate") as string} values={{}} required />
          {/* <DatePicker
              className={controlClass.control}
              firstDayOfWeek={firstDayOfWeek}
              strings={datePickerStrings}
              placeholder={t("nav.selectDate") as string}
              ariaLabel={t("nav.selectDate") as string}
              value={value!}
              onSelectDate={onSelectDate}
              formatDate={onFormatDate}
              minDate={today}
              parseDateFromString={onParseDateFromString}
            /> */}
        
          <FormDropDown
            headerText={t("nav.panelFileType") as string}
            name="documentType"
            options={[
              {key: 1, text: t("nav.fileTypeContract")},
              {key: 2, text: t("nav.fileTypeAcceptanceReport")},
              {key: 3, text: t("nav.fileTypeHandoverProtocol")}
          ]} />

          <FormDropDown
            headerText={t("nav.panelQuantity") as string}
            name="containersNumber"
            options={[
              { key: 0, text: "0"},
              { key: 1, text: "1"},
              { key: 2, text: "2"}
          ]} />

          <FileInput name="file" onChange={arrangementFileHandler} /> <br />

          <div className={btns}>
            <PrimaryButton text={t("nav.add") as string} type="submit" styles={buttonS} />
            <DefaultButton text={t("nav.cancel") as string} type="reset" onClick={cancel} />
          </div>
          </Stack.Item>
            <div className={margin}>
              {isLoading ? <ActivityIndicator /> : <ErrorMessage />}
            </div>
          </Stack>
        </Form>
        )}
    </Formik>
  )
};

export default FilesUploadForm;